<style lang="scss" scoped>
.dropdown {
    position: relative;
    display: inline-block;
}

.dropdown-title{
    color: #fff;
    font-size: 15px;
    text-transform: uppercase;
    font-weight: 800;
    letter-spacing: 0;
    line-height: 16px;
    padding: 0 0 20px 0;
    @media screen and (max-width: 1024px) {
        color: white;
    }
}
.dropdown-title:after{
    content: "▾";
    font-size: 10px;
    position: absolute;
    padding: 0px 0 0 4px;
}
.dropdown-title:hover{
    color: #00A3FF;
}

.dropdown-content {
    display: none;
    position: absolute;
    right: -10px;
    top: 28px;
    background-color: #FFFFFF;
    min-width: 160px;
    box-shadow: 0 2px 8px 0 rgba(0,0,0,0.12);
    border: 1px solid #F3F6F9;
    border-radius: 4px;
    z-index: 1;
    color: #041930;
    font-size: 15px;
    letter-spacing: 0;
    line-height: 16px;
    font-weight: 800;
    padding: 20px 0 0px 16px;
}

.dropdown:hover .dropdown-content {
    display: block;
    background-color: #F3F6F9;
}

.dropdown-content a{
    padding: 0 0px 16px 0!important;
}

.dropdown-content a:hover{
    background-color: #F3F6F9;
}
.active-language{
    color: #00A3FF;
    font-size: 15px;
    letter-spacing: 0;
    line-height: 16px;
}
</style>

<template>
    <div class="dropdown text-button rounded-button border border-white bg-transparant my-auto font-bold px-40 py-24" id="languageNav">
        <a class="text-uppercase dropdown-title">{{ val }}</a>
        <div class="dropdown-content">

        <span  class="flex flex-col">
          <a :class='val == "nl" ? "active-language" : ""' href="/">Nederlands</a>
          <a :class='val == "fr" ? "active-language" : ""' href="/fr">Français</a>
          <!-- <a :class='val == "en" ? "active-language" : ""' href="/en">English</a> -->
        </span>

        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
        }
    },
    props: {
        val: {
            type: String
        },
    },
    methods: {
    }
}
</script>
